export const navLinks = [
  { label: '直达入口', href: '#entry' },
  { label: '实时状态', href: '#status' },
  { label: '热度榜', href: '#trending' },
  { label: '讨论区', href: '#discussion' },
  { label: '访问指南', href: '#guide' },
];

export const heroStats = [
  { value: '4 条', label: '有效入口' },
  { value: '1.2w', label: '今日访问' },
  { value: '每小时', label: '自动校验' },
];

export const entryCards = [
  {
    icon: 'ri-links-line',
    title: '黑料官网入口',
    desc: '主访问通道，点开即为官网首页，无需跳转中间页。',
    tag: '推荐',
    value: 'entry://heilio/home',
  },
  {
    icon: 'ri-global-line',
    title: '黑料官网网址',
    desc: '当前生效的域名，每小时校验一次，失效自动替换。',
    tag: '实时',
    value: 'url://heilio/current',
  },
  {
    icon: 'ri-map-pin-2-line',
    title: '黑料官网地址',
    desc: '备用访问地址，主线路拥挤时一键切换，不耽误浏览。',
    tag: '备用',
    value: 'addr://heilio/backup',
  },
  {
    icon: 'ri-flashlight-line',
    title: '黑料官网直达',
    desc: '常用页面直接收藏，下次点开即达目标页，省去搜索。',
    tag: '快捷',
    value: 'jump://heilio/direct',
  },
];

export const accessPaths = [
  { label: '主站首页路径', path: '/home', status: '可访问', latency: '26ms', updated: '1 分钟前' },
  { label: '备用线路 A', path: '/a/entry', status: '可访问', latency: '48ms', updated: '3 分钟前' },
  { label: '备用线路 B', path: '/b/entry', status: '可访问', latency: '73ms', updated: '6 分钟前' },
  { label: '镜像地址', path: '/mirror', status: '维护中', latency: '--', updated: '12 分钟前' },
];

export const trendingList = [
  { rank: 1, title: '本周讨论热度最高的三个话题合集', heat: '9.8w', trend: 'up' },
  { rank: 2, title: '老粉整理的入坑时间线，新人建议先看', heat: '8.6w', trend: 'up' },
  { rank: 3, title: '关于「吃瓜礼仪」的十条社区共识', heat: '7.9w', trend: 'up' },
  { rank: 4, title: '本周被反复追问的五个问题，统一回复', heat: '6.4w', trend: 'flat' },
  { rank: 5, title: '深夜电台：那些没被公开的边角料', heat: '5.7w', trend: 'up' },
  { rank: 6, title: '榜单复盘：上周热度前十都聊了什么', heat: '5.1w', trend: 'down' },
  { rank: 7, title: '新人必读：如何正确使用本站入口', heat: '4.5w', trend: 'up' },
  { rank: 8, title: '资源整理党上线，收藏夹这下满了', heat: '3.8w', trend: 'flat' },
  { rank: 9, title: '争议话题投票结果：多数人选择沉默', heat: '3.2w', trend: 'down' },
  { rank: 10, title: '考古专区开放，老帖限时回看', heat: '2.6w', trend: 'up' },
];

export const trendingTags = [
  { label: '入口指引', count: '2.1w' },
  { label: '话题合集', count: '1.7w' },
  { label: '新人问答', count: '1.3w' },
  { label: '站务公告', count: '9.4k' },
  { label: '深夜电台', count: '7.2k' },
  { label: '考古专区', count: '5.6k' },
];

export const discussions = [
  {
    title: '入口又变了？这份最新地址先存好',
    summary:
      '不少朋友反馈原来的入口打不开，我们把当前可用的几条线路重新核对了一遍，整理成一份随时更新的清单。',
    comments: 1286,
    time: '2 小时前',
    tag: '入口更新',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20editorial%20illustration%20of%20stacked%20paper%20cards%20and%20route%20lines%2C%20terracotta%20and%20cream%20palette%2C%20soft%20textured%20background%2C%20minimal%20magazine%20style%2C%20harmonious%20composition%2C%20high%20detail&width=500&height=500&seq=heilio-disc-01&orientation=squarish',
  },
  {
    title: '第一次来，从哪里开始看比较合适',
    summary:
      '页面内容不少，新人容易迷路。这里按热度和时间两个维度给了三条推荐路线，跟着走基本不会漏掉重点。',
    comments: 842,
    time: '4 小时前',
    tag: '新手指引',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20editorial%20illustration%20of%20a%20compass%20and%20folded%20map%20shapes%2C%20terracotta%20and%20cream%20palette%2C%20soft%20textured%20background%2C%20minimal%20magazine%20style%2C%20harmonious%20composition%2C%20high%20detail&width=500&height=500&seq=heilio-disc-02&orientation=squarish',
  },
  {
    title: '热度榜的排序逻辑到底看什么',
    summary:
      '有人好奇榜单是怎么排的。简单说，综合了讨论量、回看率和新增收藏三个维度，每晚十二点统一更新。',
    comments: 613,
    time: '6 小时前',
    tag: '站务说明',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20editorial%20illustration%20of%20rising%20bar%20charts%20and%20ranking%20ribbons%2C%20terracotta%20and%20cream%20palette%2C%20soft%20textured%20background%2C%20minimal%20magazine%20style%2C%20harmonious%20composition%2C%20high%20detail&width=500&height=500&seq=heilio-disc-03&orientation=squarish',
  },
  {
    title: '收藏党请进：一键打包本周精选',
    summary:
      '把本周讨论度最高的内容做成一个合集，标题加短摘要，几分钟就能扫完，适合碎片时间慢慢看。',
    comments: 497,
    time: '9 小时前',
    tag: '内容精选',
    image: '',
  },
  {
    title: '移动端排版优化啦，说说你的感受',
    summary:
      '这周调整了手机端的阅读宽度和字号，长文看起来舒服多了。还有哪里别扭，评论区直接告诉我们。',
    comments: 356,
    time: '11 小时前',
    tag: '体验反馈',
    image: '',
  },
  {
    title: '为什么有些内容会突然下架',
    summary:
      '统一解释一下：涉及版权或当事人申诉的内容会做临时处理，处理完会重新上架，并不是被彻底删掉了。',
    comments: 288,
    time: '14 小时前',
    tag: '常见疑问',
    image: '',
  },
];

export const guideSteps = [
  { step: '01', title: '确认当前入口', desc: '以本页展示的「官网入口」为准，其他来源的链接请先核对再使用。' },
  { step: '02', title: '保存备用地址', desc: '把「备用地址」一并收藏，主线路偶尔拥挤时可以无缝切换。' },
  { step: '03', title: '收藏直达链接', desc: '常用页面用「直达链接」存进书签，下次点开就是目标页。' },
  { step: '04', title: '关注更新动态', desc: '状态栏会显示线路的实时可用情况，更新后回到本页即可。' },
];

export const faqs = [
  {
    q: '为什么有时候找不到官网？',
    a: '域名和线路会不定期调整，直接搜索容易出现仿冒站点。建议收藏本页，入口发生变化时会第一时间同步更新。',
  },
  {
    q: '入口、网址、地址有什么区别？',
    a: '入口是主访问通道，网址是当前生效的域名，地址是备用线路。三者用途不同，建议全部保存下来。',
  },
  {
    q: '页面打不开应该怎么办？',
    a: '先看实时状态栏，若显示维护中，切换备用地址即可；如果全部异常，稍等几分钟后刷新本页再试。',
  },
  {
    q: '浏览内容需要注册登录吗？',
    a: '浏览首页内容不需要注册。本页只提供入口指引，不会收集你的任何账号或隐私信息。',
  },
  {
    q: '入口大概多久更新一次？',
    a: '状态每小时自动校验一次，入口如有调整会立即在本页更新，并在顶部标注具体的更新时间。',
  },
];